export interface IGray {
	gray05_bg: string;
	gray10: string;
	gray15: string;
	gray20: string;
	gray30: string;
	gray40: string;
	gray50: string;
	gray60: string;
	gray70: string;
	gray80_text: string;
	gray90: string;
	gray_white: string;
	gray_black: string;
}

const gray: IGray = {
	gray05_bg: '#F8F9FA',
	gray10: '#F1F3F5',
	gray15: '#DEE2E6',
	gray20: '#ADB5BD',
	gray30: '#868E96',
	gray40: '#6D757E',
	gray50: '#5F666D',
	gray60: '#51575C',
	gray70: '#3B4044',
	gray80_text: '#31363A',
	gray90: '#212529',
	gray_white: '#FFFFFF',
	gray_black: '#000000',
};

export default gray;
